import React from 'react';
import dynamic from 'next/dynamic';
import Loader from './Loader';

export const NavigationLoader = () => (
  <div style={{ height: '56px', width: '100%' }}>
    <Loader fullScreen />
  </div>
);

const DynamicNavigation = dynamic(() => import('./Navigation'), {
  ssr: false,
  loading: NavigationLoader,
});

export default DynamicNavigation;
